import React, { createContext, useContext, useMemo, useState } from 'react';
import proptypes from 'prop-types';
import { track } from '../utils';
import { ENTRY_TYPES } from '../constants';

const { node, string, bool, shape, arrayOf, oneOf } = proptypes;

const FuelTypeContext = createContext({
  children: null,
  itemId: '',
  isCaching: false
});
export const useFuelType = () => useContext(FuelTypeContext);

export const FuelTypeProvider = ({
  children,
  entryType,
  position,
  header,
  drawerStatus
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const onAlertClick = () => {
    setDrawerOpen(true);
    track({ eventType: 'click' });
  };

  const {
    types,
    categories,
    isDryer,
    isRange,
    hasElectric,
    hasGas,
    hasInduction,
    hasDualFuel,
    hasHeatpump
  } = drawerStatus;

  const value = useMemo(() => ({
    entryType,
    position,
    onAlertClick,
    drawerOpen,
    setDrawerOpen,
    header,
    types,
    categories,
    isDryer,
    isRange,
    hasElectric,
    hasGas,
    hasInduction,
    hasDualFuel,
    hasHeatpump
  }), [
    entryType,
    position,
    onAlertClick,
    drawerOpen,
    setDrawerOpen,
    header,
    types,
    categories,
    isDryer,
    isRange,
    hasElectric,
    hasGas,
    hasInduction,
    hasDualFuel,
    hasHeatpump
  ]);

  return (
    <FuelTypeContext.Provider value={value}>
      {children}
    </FuelTypeContext.Provider>
  );
};

FuelTypeProvider.propTypes = {
  children: node.isRequired,
  entryType: oneOf(ENTRY_TYPES).isRequired,
  position: oneOf(['left', 'right']).isRequired,
  header: shape({
    shouldShowHeader: bool,
    headerName: string,
    headerLabel: string
  }).isRequired,
  drawerStatus: shape({
    types: arrayOf(string).isRequired,
    categories: arrayOf(string).isRequired,
    isDryer: bool,
    isRange: bool,
    hasElectric: bool,
    hasGas: bool,
    hasInduction: bool,
    hasDualFuel: bool,
    hasHeatpump: bool
  }).isRequired
};
